const hooks = {
    navigation: [],
    requestLogin: [],
    requestSignup: [],
};

function ensureHookExists (name) {
    if (name in hooks) {
        return true;
    }
    console.error('Invalid hook name "' + name + '"');
    return false;
}

function isRegistered (name) {
    if (! ensureHookExists(name)) {
        return false;
    }

    return hooks[name].length > 0;
}

const hookHandler = {
    run (name, params = {}) {
        if (! ensureHookExists(name)) {
            return;
        }
        let isHandled = false;

        for (const cb of hooks[name]) {
            isHandled = !!cb(params);
            if (isHandled) {
                break;
            }
        }

        return isHandled;
    },
    on (name, callback) {
        if (! ensureHookExists(name)) {
            return;
        }
        hooks[name].push(callback);
    },
    off (name, callback) {
        if (! ensureHookExists(name)) {
            return;
        }
        const i = hooks[name].indexOf(callback);
        if (i >= 0) {
            hooks[name].splice(i, 1);
        }
    },
    isRegistered,
};

import { runQueryActions } from '../../queryActions';
hookHandler.on('navigation', (data) => {
    if (runQueryActions(data.url)) {
        // If the link is for our own query actions, block the navigation
        return true;
    }
    return false;
});

export default hookHandler;